import PromotionsAnalysisTable from './promotions-analysis-table.vue';
import CompareFiltersBar from './compare-filters-bar.vue';

export default PromotionsAnalysisTable;
export {
    CompareFiltersBar,
};
